import React from 'react'
import { prop } from 'ramda'
import Textarea from 'react-textarea-autosize'
import classnames from 'classnames'

import { withTheme } from 'modules/util'

import {
  iconEvidence as evidence,
  iconReasoning as reasoning,
  iconCounterargument as counterargument
} from 'modules/ui/assets'

import elementTheme from './theme.scss'

const placeholders = {
  evidence: 'What makes you agree?',
  reasoning: 'Why does that make you agree?',
  counterargument: 'How could you argue against this?'
}

export function Element(props) {
  const { active, editable, first, onInput, theme, type, value } = props

  const icon = prop(type, { evidence, reasoning, counterargument })
  const className = classnames(theme.element, {
    [theme.collapsed]: !active
  })

  return (
    <div className={className}>
      <img alt={`${type} icon`} className={theme.icon} src={icon} />

      <div className={theme.curtain}>
        <div className={theme.type}>{type}</div>
        <div className={theme.clip}>
          <Textarea
            autoFocus={first}
            className={theme.value}
            disabled={!editable}
            maxRows={3}
            placeholder={placeholders[type]}
            value={value}
            onChange={event => onInput(type, event.target.value)}
          />
        </div>
      </div>
    </div>
  )
}

export default withTheme(elementTheme, Element)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Part/Element/index.js